/**
 * main.js
 *
 * Bootstraps Vuetify and other plugins then mounts the App`
 */

// Components
import App from './App.vue'
import router from './router'
import './assets/style.scss'
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css'
import VueTelInput from 'vue-tel-input'
import EN from './locale/en.json'
import TH from './locale/th.json'
import 'vue-tel-input/vue-tel-input.css'

// Composables
import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'
// Plugins
import { registerPlugins } from '@/plugins'

import * as Sentry from '@sentry/vue'

const app = createApp(App)
const i18n = createI18n({
	legacy: false,
	locale: 'TH',
	messages: {
		EN: EN,
		TH: TH,
	},
})
Sentry.init({
	app,
	dsn: import.meta.env.VITE_SENTRY_DSN,
	environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
	sampleRate: import.meta.env.VITE_SENTRY_SAMPLE_RATE,
	integrations: [
		Sentry.browserTracingIntegration({ router }),
		// Sentry.replayIntegration()
	],
	tracesSampleRate: import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE,
	profilesSampleRate: import.meta.env.VITE_SENTRY_PROFILE_SAMPLE_RATE,
	// Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
	tracePropagationTargets: ['localhost', /^https:\/\/prospace.baksters\.com/],
	// Session Replay
	// replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
	// replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
})

registerPlugins(app)
app.use(VueTelInput)
app.use(i18n)
app.component('QuillEditor', QuillEditor)
app.mount('#app')
